function checkPubgGames() {
  let list = Object.create(null);
  $(".ongoing[data-royal-tournament]").each(function(index) {
    let el = $(this);
    let isLastElement =
      index === $(".ongoing[data-royal-tournament]").length - 1;
    let name = el.attr("data-royal-tournament");
    el.css("display", "none");
    if (!(name in list)) {
      list[name] = true;
    }
    if (isLastElement && name in list) {
      el.css("display", "flex");
    }
  });
}

export { checkPubgGames };



// WEBPACK FOOTER //
// ./scripts/components/pubg-filter.js